import { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Ikon, { type IkonAd } from './Ikon';

/**
 * İKİNCİ DÜZEY PANEL — ana menü ikon şeridine inince yanında açılan liste
 * (Ayarlar bunu kullanır; Site ve Raporlar da aynı bileşenle alınabilir).
 *
 * Üstte "‹ Başlık" (ana menüye döner), altında panel içi arama, sonra bölümler.
 * Arama doluyken bölüm listesi yerine eşleşen kayıtlar görünür.
 * `gomulu`: dar ekranda içerik alanında tam genişlikte liste olarak çizilir.
 */
export type AltPanelOge = { to: string; ad: string; ikon: IkonAd; aciklama?: string };
export type AltPanelSonuc = { anahtar: string; ad: string; nerede: string; to: string };

export default function AltPanel({ baslik, geri, geriEtiket, ust, ogeler, aramaYer, ara, alt, gomulu }: {
  baslik: string; geri: () => void; geriEtiket: string;
  ust?: React.ReactNode; ogeler: AltPanelOge[];
  aramaYer?: string; ara?: (q: string) => AltPanelSonuc[];
  alt?: React.ReactNode; gomulu?: boolean;
}) {
  const [q, setQ] = useState('');
  const sonuclar = useMemo(() => (ara && q.trim() ? ara(q) : null), [ara, q]);
  return (
    <aside className={`ccd-altpanel${gomulu ? ' ccd-altpanel-gomulu' : ''}`} aria-label={baslik}>
      <button type="button" className="ccd-altpanel-geri" onClick={geri} title={geriEtiket} aria-label={geriEtiket}>
        <Ikon ad="geri" boy={18} /><span>{baslik}</span>
      </button>
      {ara && (
        <label className="ccd-altpanel-ara">
          <Ikon ad="arama" boy={16} />
          <input type="search" className="ccd-altpanel-girdi" value={q} onChange={(e) => setQ(e.target.value)} placeholder={aramaYer ?? 'Ara'} aria-label={aramaYer ?? 'Ara'}
                 onKeyDown={(e) => { if (e.key === 'Escape' && q) { e.stopPropagation(); setQ(''); } }} />
        </label>
      )}
      {ust && !sonuclar && <div className="ccd-altpanel-ust">{ust}</div>}
      <nav className="ccd-altpanel-liste">
        {sonuclar ? (
          sonuclar.length === 0 ? <div className="ccd-altpanel-bos">Eşleşen ayar yok.</div> : sonuclar.map((s) => (
            <NavLink key={s.anahtar} to={s.to} className="ccd-altpanel-oge ccd-altpanel-sonuc" onClick={() => setQ('')}>
              <span className="ccd-altpanel-metin"><span>{s.ad}</span><span className="ccd-altpanel-nerede">{s.nerede}</span></span>
            </NavLink>
          ))
        ) : ogeler.map((o) => (
          <NavLink key={o.to} to={o.to} className={({ isActive }) => `ccd-altpanel-oge${isActive ? ' ccd-is-active' : ''}`}>
            <Ikon ad={o.ikon} boy={18} />
            <span className="ccd-altpanel-metin"><span>{o.ad}</span>{gomulu && o.aciklama && <span className="ccd-altpanel-nerede">{o.aciklama}</span>}</span>
            {gomulu && <Ikon ad="ok" boy={16} className="ccd-altpanel-git" />}
          </NavLink>
        ))}
      </nav>
      {alt && <div className="ccd-altpanel-alt">{alt}</div>}
    </aside>
  );
}
